import { render, staticRenderFns } from "./GlobalSnackbar.vue?vue&type=template&id=7c3c19bb&scoped=true&"
import script from "./GlobalSnackbar.vue?vue&type=script&lang=js&"
export * from "./GlobalSnackbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3c19bb",
  null
  
)

export default component.exports